import { useQuery } from '@tanstack/react-query'
import useApiService from 'services/api'

/**
 * Custom hook to fetch either company or door proxy data based on context.
 * When on a door page (doorProxyId provided), fetches door proxy data.
 * Otherwise, fetches company data.
 *
 * @param chainProxyId - The chain proxy (company) ID
 * @param doorProxyId - Optional door proxy ID (when on door page)
 * @returns Object containing data, refetch function, and isDoorPage flag
 */
export function useCompanyOrDoorData(
  chainProxyId: number,
  doorProxyId?: number
) {
  const api = useApiService()

  const { data: companyData, refetch: refetchCompany } = useQuery({
    queryKey: ['company', chainProxyId],
    queryFn: () => api.getCompany(chainProxyId),
    enabled: !!chainProxyId && !doorProxyId,
  })

  const { data: doorProxyData, refetch: refetchDoorProxy } =
    api.useGetDoorProxy(doorProxyId)

  return {
    data: doorProxyId ? doorProxyData : companyData,
    refetch: doorProxyId ? refetchDoorProxy : refetchCompany,
    isDoorPage: !!doorProxyId,
  }
}
